// @core/api/endpoints/knowledge/list_sources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSourcesResponse,
} from '../../../types/knowledge';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/knowledge';

/**
 * List sources
 * Lists the sources attached to a knowledge base with their indexing status.
 */
export async function ListSources(
  base_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSourcesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id/sources`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  const requestOptions = options;
  return client.get<ListSourcesResponse>(requestPath, { ...requestOptions, params });
}
